// extracted by mini-css-extract-plugin
export default {"OptionsPage":"OptionsPage_OptionsPage__936W2","pageRow":"OptionsPage_pageRow__+H6yr","title":"OptionsPage_title__ExDSB"};